import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'stop',
  templateUrl: './stop.component.html',
  styleUrls: ['./stop.component.scss'],
  standalone: true,
})
export class StopComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
